import React, { Component } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import { Divider } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/core/styles';
import Article from './article';
import Immutable from 'seamless-immutable';

function compareArticle(a, b){
  if (!a.name) return 1;
  if (!b.name) return -1;
  return a.name.localeCompare(b.name);
}

class ArticleList extends Component {
  render() {
    const { classes, value, showPrices, showTip, tip, labelPrinting, printProductLabels, printingProductLabels } = this.props;

    let keynumber = 0;

    const articles = Immutable.asMutable(value).sort(compareArticle).map((a, i) => {
      const divider = i === value.length - 1 ? null : <Divider light />;
      return (
        <div key={keynumber++}>
          <ListItem>
            <Article 
              value={a} 
              printProductLabels={printProductLabels}
              showPrice={showPrices}
              printing={a.entries && a.entries.some(x => printingProductLabels && !!printingProductLabels[x.id])}
              labelPrinting={labelPrinting}
            />
          </ListItem>
          {divider}
        </div>
      );
    });

    return (
      <div className={classes.root}>
        <List dense>
          {articles}
          {(showTip && tip)
            ? (
              <div>
                <Divider light />
                <ListItem>
                  <Article
                    value={{
                      quantity: ' ',
                      name: 'Trinkgeld',
                      price: tip
                    }}
                    showPrice />
                </ListItem>
              </div>
            )
            : null
          }
        </List>
      </div>
    );
  }
}

const styles = () => ({
  root: {
  },

});

ArticleList.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.array.isRequired,
};

ArticleList.defaultProps = {
  articles: [],
};

export default withStyles(styles)(ArticleList);
